import React from 'react';
import {Typography} from 'antd';
import {ModelDTO} from 'hemwb-api';
import {fields as metadataFieldLabels} from '../common/ModelEdit/ModelEditMetadata/constants';

const {Text} = Typography;

interface NotesAndLinksTabProps {
  model: ModelDTO | null;
}

const renderLinks = (value: string) => {
  if (!value) return null;

  const parseSegments = (line: string) => {
    const segments: Array<{type: 'text' | 'url'; value: string}> = [];
    const urlRegex = /https?:\/\/[^\s]+/g;
    let lastIndex = 0;
    let match;
    while ((match = urlRegex.exec(line)) !== null) {
      if (match.index > lastIndex) segments.push({type: 'text', value: line.slice(lastIndex, match.index)});
      segments.push({type: 'url', value: match[0]});
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < line.length) segments.push({type: 'text', value: line.slice(lastIndex)});
    return segments;
  };

  const lines = value.split('\n').filter((line) => line.trim() !== '');

  return (
    <div
      style={{
        padding: '8px 0px',
        minHeight: 120,
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      {lines.map((line, idx) => {
        const segments = parseSegments(line.trim());
        return (
          <span key={idx} style={{wordBreak: 'break-all'}}>
            {segments.map((seg, segIdx) =>
              seg.type === 'url' ? (
                <a key={segIdx} href={seg.value} target="_blank" rel="noopener noreferrer" style={{color: '#006A63'}}>
                  {seg.value}
                </a>
              ) : (
                <Text key={segIdx} style={{wordBreak: 'break-all'}}>
                  {seg.value}
                </Text>
              ),
            )}
          </span>
        );
      })}
    </div>
  );
};

export const NotesAndLinksTab: React.FC<NotesAndLinksTabProps> = ({model}) => {
  const notes = model?.metadata?.notes ?? '';
  const links = model?.metadata?.training_and_publication_link ?? '';

  return (
    <div>
      <div style={{marginBottom: 24}}>
        <Text style={{display: 'block', marginBottom: 8, fontSize: '14px', color: '#595959', fontWeight: 500}}>
          {metadataFieldLabels['notes']}
        </Text>
        <div style={{resize: 'none', cursor: 'default', border: '0px', color: '#000000'}}>{notes}</div>
      </div>

      <div>
        <Text style={{display: 'block', marginBottom: 8, fontSize: '14px', color: '#595959', fontWeight: 500}}>
          {metadataFieldLabels['training_and_publication_link']}
        </Text>
        {links ? renderLinks(links) : null}
      </div>
    </div>
  );
};
